<template>
  <div class="container-main">
    <div class="container-app">
      <div
        :style="{background: `${this.appBgColor}`}"
        class="icon">
        <i :class="appIcon"/>
      </div><data value=""/>
      <div class="name">
        <strong>
          {{ appTitle }}
        </strong>
      </div>
    </div>
    <ul class="container-list">
      <li
        v-for="(value, index) in list"
        :key="index"
        :class="['item', color]"
      >
        - {{ value }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModuleTransactionCount',

  props: {
    appId: {
      type: Number,
      required: true,
    },

    list: {
      type: Array,
      default: () => [],
      validator: (list) => {
        return list.every((value) => typeof value === 'string')
      },
    },

    color: {
      type: String,
      default: () => 'danger',
    },
  },

  computed: {
    ...mapGetters({
      getAppInfo: 'getAppInfo',
    }),

    appInfo () {
      return this.getAppInfo(this.appId).translate
    },

    appTitle () {
      return this.$t(`${this.appInfo}.title`)
    },

    appBgColor () {
      return this.$t(`${this.appInfo}.bgcolor`)
    },

    appIcon () {
      return this.$t(`${this.appInfo}.icon`)
    },
  },
}
</script>

<style scoped>
.container-main {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
}

.container-main:last-of-type {
  margin-bottom: 0;
  border-bottom: none;
}

.container-main:last-of-type .container-list {
  margin-bottom: 0;
}

.container-app {
  display: flex;
}

.container-app .icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 20px;
  color: #fff;
}

.container-app .name {
  flex: 1;
  display: flex;
  align-items: center;
}

.container-list {
  margin-top: 10px;
  margin-bottom: 6px;
}

.container-list .item {
  margin-bottom: 4px;
}

.container-list .item.danger {
  color: var(--danger);
}
</style>



// WEBPACK FOOTER //
// src/components/custom/ModuleTransactionCount.vue